import diyDialog from './diyDialog.vue'
const diy_dialog = {
    install: function(Vue) {
        Vue.component('diy_dialog', diyDialog)
    }
};
// 导出组件
export default diy_dialog